import types from './types';

const toggleSidebar = () => ({
  type: types.TOGGLE_SIDEBAR
});
const toggleErrorPage = errorData => ({
  type: types.TOGGLE_ERROR_PAGE,
  params: { errorData }
});

const getNotification = () => ({
  type: types.GET_NOTIFICATION
});

export default {
  toggleSidebar,
  toggleErrorPage,
  getNotification
};
